<template>
<div class="chapter">
<div class="inner_page">
<a id="page_xiv"></a>
<h3 class="fmtitle">Abbreviations</h3>
<table class="table1">
<tbody>
<tr>
<td class="noindent">AFT</td>
<td class="noindentz">Bureau of Alcohol, Firearms, Tobacco and Explosives</td>
</tr>
<tr>
<td class="noindent">CIA</td>
<td class="noindent">Central Intelligence Agency</td>
</tr>
<tr>
<td class="noindent">DA</td>
<td class="noindent">District Attorney</td>
</tr>
<tr>
<td class="noindent">DEA</td>
<td class="noindent">Drug Enforcement Agency</td>
</tr>
<tr>
<td class="noindent">FBI</td>
<td class="noindent">Federal Bureau of Investigation</td>
</tr>
<tr>
<td class="noindent">HSCA</td>
<td class="noindent">House Select Committee on Assassinations</td>
</tr>
<tr>
<td class="noindent">LAPD</td>
<td class="noindent">Los Angeles Police Department</td>
</tr>
<tr>
<td class="noindent">MLK</td>
<td class="noindent">Martin Luther King Jr</td>
</tr>
<tr>
<td class="noindent">OAS</td>
<td class="noindent">Organization of Arab Students</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Abbreviations.vue?7a2c67e7